module.exports = __webpack_public_path__ + "img/dana.b48d05d3.png";